'use client';

import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["users"];
import { DropdownUserItem } from "../../primitive-dropdown/dropdown-user-item";
import { AsyncGenericDropdown } from "./async-generic-dropdown";
import { jsx as _jsx } from "react/jsx-runtime";
export function AsyncUsersDropdown(_ref) {
  var users = _ref.users,
    props = _objectWithoutProperties(_ref, _excluded);
  var options = users.map(function (option) {
    return {
      value: option.value,
      label: option.name,
      element: function element(elementProps) {
        return /*#__PURE__*/_jsx(DropdownUserItem, _objectSpread({
          user: option
        }, elementProps));
      }
    };
  });
  return /*#__PURE__*/_jsx(AsyncGenericDropdown, _objectSpread(_objectSpread({}, props), {}, {
    options: options
  }));
}